import { useCallback } from 'react';

export const usePeriodBlockHandlers = ({ startDate, onClick }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(startDate);
    }
  }, [startDate, onClick]);

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (onClick) {
          onClick(startDate);
        }
      }
    },
    [startDate, onClick]
  );

  return {
    handleClick,
    handleKeyDown
  };
};

export default usePeriodBlockHandlers;
